import type { VaasCourse, VaasEditValues, VaasLesson } from "~/v2/types/vaas"

export const validateVaasForPublish = ({
  course,
  lesson,
  values,
}: {
  course?: VaasCourse | null
  lesson?: VaasLesson | null
  values?: VaasEditValues | null
}): string | null => {
  if (!values?.course_name?.trim()) {
    return "Course name is required before publish."
  }

  if (!values?.course_thumbnail?.public_id && !course?.thumbnail?.public_id) {
    return "You must upload a thumbnail before publish."
  }

  if (!lesson?.video_id) {
    return "You must upload a video before publish."
  }

  if (!lesson?.captions?.length) {
    return "You must upload an SRT before publish."
  }

  if (!values?.created_by) {
    return "Created by is required before publish."
  }

  return null
}
